/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1AppsDeleteAppRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
};

/** @internal */
export type V1AppsDeleteAppRequestBody$Outbound = {
  project: string;
  app: string;
};

/** @internal */
export const V1AppsDeleteAppRequestBody$outboundSchema: z.ZodType<
  V1AppsDeleteAppRequestBody$Outbound,
  z.ZodTypeDef,
  V1AppsDeleteAppRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
});

export function v1AppsDeleteAppRequestBodyToJSON(
  v1AppsDeleteAppRequestBody: V1AppsDeleteAppRequestBody,
): string {
  return JSON.stringify(
    V1AppsDeleteAppRequestBody$outboundSchema.parse(v1AppsDeleteAppRequestBody),
  );
}
